PJQ.collections.meetings = {};

PJQ.models.meetings = {};

PJQ.views.meetings = {};

PJQ.modules.meetings = {
    routes: [
        {
            route: 'projects/:projectId/meetings',
            name: 'meetings',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "meetings");
            }
        },
        {
            route: 'projects/:projectId/meetings/:meetingId',
            name: 'meeting',
            callback: function (projectId, meetingId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "meetings", {
                    meetingId: parseInt(meetingId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.meetings.routes);

PJQ.views.meetings.MeetingEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-meeting-edit'),
        subTemplates: {
            agendaItems: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'agenda-items'),
            agendaItem: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'agenda-item')
        },
        width: '95%',
        maxWidth: 1200,
        minWidth: 700,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-save': 'saveMeeting',
        'click .btn-delete': 'deleteMeeting',
        'click .btn-close': 'close',
        'click .nav-link': 'changeActiveView',
        'click .btn-add-agenda-item': 'addAgendaItemClicked',
        'click .btn-close-agenda-item': 'closeAgendaItemClicked',
        'click .btn-open-agenda-item': 'openAgendaItemClicked',
        'click .btn-edit-agenda-item': 'editAgendaItemClicked',
        'click .btn-delete-agenda-item': 'deleteAgendaItemClicked',
        'click .btn-add-category': 'addCategoryClicked',
        'click .btn-edit-category': 'editCategoryClicked',
        'click .btn-delete-category': 'deleteCategoryClicked',
        'click .btn-edit-minutes': 'editMeetingMinutes',
        'click .btn-save-minutes': 'saveMeetingMinutesClicked',
        'click .category-dropdown': 'categoryClicked',
        'click .btn-view-transcription': 'viewTranscription',
        'click .btn-export': 'exportMeeting',
        'click .btn-cancel-minutes': 'cancelMeetingMinutes',
        'keydown .meeting-number': 'numbersOnly',
        'click .btn-distribute': 'distributeAgendaItems',
        'click .btn-view-previous-minutes': 'viewPreviousMinutes',
        'click .toggle-attendance': 'toggleAttendance',
        'input .meeting-description': 'descriptionChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.model == null) {
            this.model = new PJQ.models.meetings.Meeting({
                projectId: this.options.project?.id,
                templateId: this.options.templateId,
                statusId: 1,
                number: 1
            });
        }

        if (this.options.project) {
            this.customFields = await this.options.project.fetchMeetingCustomFields();
        } else {
            this.customFields = await PJQ.app.session.fetchMeetingCustomFields();
        }

        if (this.options.project) {
            this.settings = await this.options.project.fetchMeetingSettings();
        } else {
            this.settings = await PJQ.app.session.fetchMeetingSettings();
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        } else {
            this.model.set('isPublic', this.settings.get('isPublicDefault'));
        }

        if (_.size(this.model.get('timezone')) === 0) {
            this.model.set('timezone', new Date().toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2]);
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        let status = this.model.get('statusId');
        if (this.options.project) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.canEdit');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canDelete = this.options.isAdmin;
            this.options.canSave = this.options.canEdit && status !== PJQ.constants.meetings.meetingStatus.CONCLUDED && status !== PJQ.constants.meetings.meetingStatus.CANCELLED;
            this.options.canUploadRecording = PJQ.app.session.project.hasPermission('meetings.canEdit')
                && status !== PJQ.constants.meetings.meetingStatus.CONCLUDED
                && status !== PJQ.constants.meetings.meetingStatus.CANCELLED;
        } else {
            this.options.canEdit = true;
            this.options.isAdmin = true;
            this.options.canDelete = this.options.isAdmin;
            this.options.canSave = this.options.canEdit && status !== PJQ.constants.meetings.meetingStatus.CONCLUDED && status !== PJQ.constants.meetings.meetingStatus.CANCELLED;
            this.options.canUploadRecording = status !== PJQ.constants.meetings.meetingStatus.CONCLUDED
                && status !== PJQ.constants.meetings.meetingStatus.CANCELLED;
        }

        this.options.canEditMinutes = (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit')) &&
            status !== PJQ.constants.meetings.meetingStatus.CONCLUDED &&
            status !== PJQ.constants.meetings.meetingStatus.CANCELLED;

        if (status === PJQ.constants.meetings.meetingStatus.IN_PROGRESS || status === PJQ.constants.meetings.meetingStatus.CONCLUDED || status === PJQ.constants.meetings.meetingStatus.CANCELLED) {
            this.options.canEdit = false;
            this.options.canDelete = false;
            this.options.canUploadRecording = status === PJQ.constants.meetings.meetingStatus.IN_PROGRESS && (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit'));
        } else if (status === PJQ.constants.meetings.meetingStatus.DRAFT) {
            this.options.canEdit = true;
            this.options.canUploadRecording = true;
        } else {
            if (PJQ.app.session.project) {
                this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.canEdit');
                this.options.canDelete = PJQ.app.session.project.hasPermission('meetings.isAdmin');
                this.options.canUploadRecording = PJQ.app.session.project.hasPermission('meetings.canEdit');
            } else {
                this.options.canEdit = true;
                this.options.canDelete = true;
                this.options.canUploadRecording = true;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            canSave: this.options.canSave,
            settings: this.settings,
            canTranscribe: _.size(_.filter(this.model.meetingRecordings.models, function (recording) {
                return !recording.get('delete')
            }, this)) > 0 && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_MEETING_TRANSCRIPTIONS)
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderGeneral();
        if (!this.model.isNew()) {
            this.renderAgendaItems();
        }
    },
    descriptionChanged: function(e) {
        let $input = $(e.currentTarget),
            val = $input.val();

        if (typeof val === 'string' && val.length > 4000) {
            val = val.slice(0, 4000);
            $input.val(val);
        }

        this.model.set('description', val);
    },
    viewPreviousMinutes: function (e) {
        let $target = $(e.currentTarget),
            $container = $target.closest('.agenda-item-container'),
            $minutes = $container.find('.previous-minutes-display');

        $minutes.off('shown.bs.collapse hidden.bs.collapse').on('shown.bs.collapse hidden.bs.collapse', function () {
            if ($minutes.hasClass('show')) {
                $container.find('.btn-view-previous-minutes').html('<i class="fas fa-angle-up mr-1"></i>');
            } else {
                $container.find('.btn-view-previous-minutes').html('<i class="fas fa-angle-down mr-1"></i>');
            }
        });

        $minutes.collapse('toggle');
    },
    changeActiveView: function (e, view) {
        let tab = e && e.target.hash ? e.target.hash.toUpperCase() : null;

        if (view) {
            tab = view;
        }

        switch (tab) {
            case '#M_AGENDA':
                this.options.activeView = 'agenda';
                break;
            default:
                this.options.activeView = 'general';
        }
    },
    renderGeneral: function () {
        let fnSaveAttachment = _.bind(function (attachment) {
            // If the attachment doesn't have an uploadId, recursively call this function every 2 seconds
            if (attachment.get('uploadId')) {
                let isNew = this.model.isNew();
                this.model.save(null, {
                    success: _.bind(function (model) {
                        if (isNew && typeof this.options.onSave === 'function') {
                            this.options.onSave(model, true);
                        }
                        this.render();
                    }, this)
                });
            } else {
                setTimeout(_.bind(function () {
                    fnSaveAttachment(attachment)
                }, this), 2000);
            }
        }, this);

        this.listenTo(this.model.meetingRecordings, 'add', _.bind(function (attachment) {
            // The attachment has been uploaded, but probably doesn't have an uploadId yet. Call fnSaveAttachment to make sure it saves
            if (attachment.get('uploadId')) {
                model.save();
            } else {
                fnSaveAttachment(attachment);
            }
        }, this));
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });
        let defaultDate = PJQ.helpers.dateHelpers.getDateString(this.model.get('date'), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
        this.datePicker = new PJQ.inputs.Datepicker({
            el: this.$('.meeting-date'),
            canEdit: this.options.canEdit,
            timezone: 'UTC',
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: defaultDate
            },
            onChange: _.bind(function (newDate) {
                let currentDate = this.model.get('date');
                if (currentDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDate)) !== 0) {
                    this.model.set('date', newDate);
                }
            }, this)
        });

        if (_.size(this.customFields) > 0) {
            this.meetingCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.meeting-custom-fields'),
                isAdmin: true,
                isEdit: this.options.canEdit,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: () => {
                    this.model.isDirty = true;
                }
            });
        }

        // Convert startTime to date for datepicker
        let startTimeString = this.model.get('startTime'),
            [startHours, startMinutes, startSeconds] = startTimeString ? startTimeString.split(':') : [0, 0, 0],
            startDate = new Date();
        startDate.setHours(startHours);
        startDate.setMinutes(startMinutes);
        startDate.setSeconds(startSeconds);

        this.startTimePicker = new PJQ.inputs.Datepicker({
            el: this.$('.meeting-start-time'),
            canEdit: this.options.canEdit,
            isTimeOnly: true,
            timezone: this.model.get('timezone'),
            isShowTimezone: true,
            isEditTimezone: true,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                defaultDate: startDate
            },
            onTimezoneChange: (tz) => {
                this.model.set('timezone', tz);
                this.endTimePicker.setTimezone(tz);
            },
            onChange: (newDate) => {
                let time = PJQ.helpers.dateHelpers.getTimeString(new Date(newDate));
                if (this.model.get('startTime') === time) {
                    return;
                }

                this.model.set('startTime', time)

                let dMinutes = this.model.durationInMinutes();
                if (dMinutes < 0) {
                    let startTime = this.model.getDateAndTime('start');
                    this.model.set('endTime', PJQ.helpers.dateHelpers.getTimeString(startTime));

                    if (this.endTimePicker) {
                        this.endTimePicker.setValue(startTime)
                    }
                }
            }
        });

        // Convert endTime to date for datepicker
        let endTimeString = this.model.get('endTime'),
            [endHours, endMinutes, endSeconds] = endTimeString ? endTimeString.split(':') : [0, 0, 0],
            endDate = new Date();
        endDate.setHours(endHours);
        endDate.setMinutes(endMinutes);
        endDate.setSeconds(endSeconds);

        this.endTimePicker = new PJQ.inputs.Datepicker({
            el: this.$('.meeting-end-time'),
            canEdit: this.options.canEdit,
            isTimeOnly: true,
            timezone: this.model.get('timezone'),
            isShowTimezone: true,
            isEditTimezone: true,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                defaultDate: endDate
            },
            onTimezoneChange: (tz) => {
                this.model.set('timezone', tz);
                this.startTimePicker.setTimezone(tz);
            },
            onChange: (newDate) => {
                let time = PJQ.helpers.dateHelpers.getTimeString(new Date(newDate));
                if (this.model.get('endTime') === time) {
                    return;
                }

                this.model.set('endTime', time)

                let dMinutes = this.model.durationInMinutes();
                if (dMinutes < 0) {
                    let endTime = this.model.getDateAndTime('end');
                    this.model.set('startTime', PJQ.helpers.dateHelpers.getTimeString(endTime));

                    if (this.startTimePicker) {
                        this.startTimePicker.setValue(endTime)
                    }
                }
            }
        });

        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            defaultValue: this.model.get('statusId') != null ? this.model.get('statusId') : 1,
            canEdit: ((!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit')) || this.options.canEdit),
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                let newStatus = value,
                    oldStatus = this.model.get('statusId');
                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.model.save(null, {
                        success: _.bind(function () {
                            this.model.dirtyAttributes = {};
                            if (typeof this.options.onSave === 'function')
                                this.options.onSave(this.model);
                            this.render();
                            PJQ.notifications.notify.successNotify({
                                message: 'Meeting saved successfully'
                            });
                        }, this)
                    })
                }
            }, this)
        });

        if (this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.DRAFT || this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.SCHEDULED) {
            this.attendeePicker = new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.meeting-attendees'),
                selectedContact: this.model.attendees.getAttendeeContacts(),
                isReadOnly: !this.options.canEdit,
                displayContactsBlock: true,
                context: PJQ.app.session.project ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: false,
                onChange: _.bind(function (selectedContacts) {
                    let arr = _.map(selectedContacts, function (contact) {
                        return contact.get('id') ? contact.get('id') : contact.id;
                    });
                    this.model.set('attendeeIds', arr);
                    this.model.attendees = new PJQ.collections.meetings.MeetingAttendees(_.map(selectedContacts, function (contact) {
                        return new PJQ.models.meetings.MeetingAttendee({
                            id: contact.id,
                            attendee: contact
                        });
                    }, this));

                    this.model.isDirty = true;
                }, this)
            });
        } else {
            this.renderAttendanceDatatable();
        }

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.meeting-file-uploader'),
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            useApiV2: true,
            canView: false,
            canDelete: this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.meetings.meetingStatus.CONCLUDED && this.model.get('statusId') !== PJQ.constants.meetings.meetingStatus.CANCELLED,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        })

        this.recordingUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.meeting-recording-uploader'),
            allowedExtensions: ['wav', 'mpeg', 'mp3', 'webm'],
            collection: this.model.meetingRecordings,
            maxFiles: 1,
            canUpload: this.options.canUploadRecording && _.size(this.model.meetingRecordings) === 0,
            useApiV2: true,
            canDelete: this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.meetings.meetingStatus.CONCLUDED && this.model.get('statusId') !== PJQ.constants.meetings.meetingStatus.CANCELLED,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                    this.model.save(null, {
                        success: _.bind(function (model) {
                            this.options.canUploadRecording = false;
                            this.render();
                        }, this)
                    });
                } else {
                    attachment.destroy();
                    this.options.canUploadRecording = false;
                    this.render();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        })
    },
    renderAttendanceDatatable: function () {
        this.attendanceTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.meeting-attendees'),
            isHideSearch: true,
            data: this.model.attendees.models,
            rowId: "cid",
            order: [0, 'asc'],
            pageLength: 10,
            language: {
                zeroRecords: 'No Scheduled Attendees'
            },
            columns: [
                {
                    "data": "attributes.attendee",
                    "title": "Name",
                    "render": (data, type, row) => {
                        let result = '';
                        if (row.attendee != null) {
                            result = PJQ.helpers.contacts.getContactAnchor({
                                id: row.attendee.id,
                                name: row.attendee.get('contactName')
                            });
                        }
                        return result;
                    }
                },
                {
                    "data": "attributes.attendee",
                    "title": "Company",
                    "render": (data, type, row) => {
                        let result = '';
                        if (row.attendee != null) {
                            return row.attendee.get('companyName');
                        }
                        return result;
                    }
                },
                {
                    "data": "attributes.isPresent",
                    "title": "Present",
                    "width": "7%",
                    "render": (data, type, row) => {
                        let html = ''
                        if (this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.IN_PROGRESS && (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit'))) {
                            html = '<div class="pretty p-switch ml-3"><input type="radio" name="attendance-' + row.cid + '" ' + (data ? 'checked' : '') + ' class="cb-primary toggle-attendance" data-attribute="isPresent"/><div class="state p-success"><label>&nbsp;</label></div></div>';
                        } else {
                            html = data ? '<i class="fas fa-check text-success"></i>' : '<i class="fas fa-times text-danger"></i>';
                        }

                        return '<div class="wd-100 text-align-center">' + (html) + '</div>'
                    }
                },
                {
                    "data": "attributes.isAbsent",
                    "title": "Absent",
                    "width": "7%",
                    "render": (data, type, row) => {
                        let html = ''
                        if (this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.IN_PROGRESS && (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit'))) {
                            html = '<div class="pretty p-switch ml-3"><input type="radio" name="attendance-' + row.cid + '" ' + (data ? 'checked' : '') + ' class="cb-primary toggle-attendance" data-attribute="isAbsent"/><div class="state p-success"><label>&nbsp;</label></div></div>';
                        } else {
                            html = data ? '<i class="fas fa-check text-success"></i>' : '<i class="fas fa-times text-danger"></i>';
                        }

                        return '<div class="wd-100 text-align-center">' + (html) + '</div>'
                    }
                },
                {
                    "data": "attributes.isDistribution",
                    "title": "For Distribution Only",
                    "width": "18%",
                    "render": (data, type, row) => {
                        let html = ''
                        if (this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.IN_PROGRESS && (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit'))) {
                            html = '<div class="pretty p-switch ml-3"><input type="radio" name="attendance-' + row.cid + '" ' + (data ? 'checked' : '') + ' class="cb-primary toggle-attendance" data-attribute="isDistribution"/><div class="state p-success"><label>&nbsp;</label></div></div>';
                        } else {
                            html = data ? '<i class="fas fa-check text-success"></i>' : '<i class="fas fa-times text-danger"></i>';
                        }

                        return '<div class="wd-100 text-align-center">' + (html) + '</div>'
                    }
                },
            ]
        });
    },
    toggleAttendance: function (e) {
        let target = $(e.currentTarget),
            attribute = target.data('attribute'),
            attendee = this.attendanceTable.getRow(target.closest('tr')).data();

        attendee.set({
            isPresent: attribute === 'isPresent',
            isAbsent: attribute === 'isAbsent',
            isDistribution: attribute === 'isDistribution'
        });
    },
    viewTranscription: function () {
        let recordings = _.filter(this.model.meetingRecordings.models, function (recording) {
                return !recording.get('delete')
            }, this),
            recording = recordings[0];

        new PJQ.views.meetings.ViewMeetingTranscriptionModal({
            model: recording,
            meeting: this.model
        });
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, false, false);
    },
    renderAgendaItems: function () {
        let categories = _.sortBy(this.model.categories.models, function (c) {
                return c.id == null ? -1 : c.id;
            }),
            categoryIds = [],
            hasUncategorizedItems = this.model.agendaItems.findWhere({categoryId: null}) != null;
        _.each(categories, _.bind(function (c) {
            if (c.id > 0 || null != this.model.agendaItems.findWhere({categoryId: c.id})) {
                categoryIds.push(c.id);
            }
        }, this));

        this.renderSubTemplate(false, this.options.subTemplates.agendaItems, this.$('.meeting-agenda'), {
            subTemplates: this.options.subTemplates,
            items: this.model.agendaItems.models,
            meetings: this.options.meetings,
            categories: categories,
            settings: this.settings,
            meeting: this.model,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            canEditMinutes: this.options.canEditMinutes,
        }, _.bind(function (el) {
            _.each(this.model.agendaItems.models, function (model) {
                let category = this.model.categories.get(model.get('categoryId')),
                    agendaNumber;

                if (category) {
                    let sortNumber = hasUncategorizedItems ? category.get('sortOrder') + 1 : category.get('sortOrder');
                    agendaNumber = sortNumber + "." + model.get('sortOrder');
                } else {
                    agendaNumber = "1." + model.get('sortOrder');
                }

                this.renderAgendaItem(model, agendaNumber);
            }, this);
        }, this));


        if (this.options.canEdit) {
            let categorySortable = new PJQ.Sortable(this.$('.agenda-items-container'), {
                items: '.category-dropdown',
                multiple: false,
                tolerance: 'pointer',
                handle: '.category-sort',
                onStart: () => {
                    this.$('.collapse').hide();
                    categorySortable.refreshPositions();
                },
                onStop: (e, ui) => {
                    this.setCategorySort(ui.item);
                }
            });

            let agendaSortable = new PJQ.Sortable(this.$('.collapse'), {
                items: '.agenda-item-outer',
                multiple: false,
                tolerance: 'pointer',
                handle: '.agenda-item-sort',
                onStart: () => {
                    agendaSortable.refreshPositions();
                },
                onStop: (e, ui) => {
                    this.setAgendaItemSort(ui.item);
                }
            });
        }
    },
    setAgendaItemSort: function (sortedEl) {
        let sortOrder = 1,
            collapseEl = this.$(sortedEl).closest('.collapse'),
            sortedCid = this.$(sortedEl).data('cid'),
            sortedItem = this.model.agendaItems.get(sortedCid),
            updateSort = false;

        _.each(collapseEl.find('.agenda-item-outer'), function (element) {
            let itemCid = this.$(element).data('cid');
            let agendaItem = this.model.agendaItems.get(itemCid);

            if (agendaItem) {
                if (agendaItem === sortedItem && sortedItem.get('sortOrder') !== sortOrder) {
                    updateSort = true;
                }

                agendaItem.set('sortOrder', sortOrder);
                sortOrder++;
            }
        }, this);

        if (updateSort) {
            sortedItem.updateSort();
        }

        this.renderAgendaItems();
    },
    setCategorySort: function (sortedEl) {
        let categories = this.model.categories.models,
            sortOrder = 1,
            sortedCid = this.$(sortedEl).data('cid'),
            sortedCategory = this.model.categories.get(sortedCid),
            updateSort = false;

        _.each(this.$('.category-dropdown'), function (category) {
            let cid = this.$(category).data('cid'),
                model = _.find(categories, function (c) {
                    return c.cid === cid;
                });

            if (model) {
                if (model === sortedCategory && model.get('sortOrder') !== sortOrder) {
                    updateSort = true;
                }

                model.set('sortOrder', sortOrder);
                sortOrder++;
            }
        });

        if (updateSort) {
            sortedCategory.updateSort();
        }
        this.renderAgendaItems();
    },
    renderAgendaItem: function (agendaItem, agendaNumber) {
        if (!agendaNumber && agendaItem.agendaNumber != null) {
            agendaNumber = agendaItem.agendaNumber;
        }
        agendaItem.agendaNumber = agendaNumber;

        let $item = this.$('.agenda-item-outer[data-cid="' + agendaItem.cid + '"]');
        this.renderSubTemplate(false, this.options.subTemplates.agendaItem, $item, {
            model: agendaItem,
            canEdit: this.options.canEdit,
            settings: this.settings,
            canEditMinutes: this.options.canEditMinutes,
            canDelete: this.options.canDelete,
            agendaNumber: agendaItem.agendaNumber,
            meetings: this.options.meetings,
        }, _.bind(function (el) {
            let $agendaItemEl = el.find('.agenda-item-container[data-cid="' + (agendaItem.cid) + '"]');

            if (agendaItem.get('isEditing')) {
                agendaItem.minutesEditor = new PJQ.inputs.HTMLEditor({
                    el: $agendaItemEl.find('.meeting-minutes-edit'),
                    defaultValue: agendaItem.get('minutes'),
                    editorHeight: 100,
                    isHideTokens: true,
                    onChange: (val) => {
                        agendaItem.set('minutes', val);
                    }
                });

                el.find('.note-editor').addClass('wd-100');
            }


            agendaItem.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $agendaItemEl.find('.agenda-item-attachments'),
                collection: agendaItem.attachments,
                canUpload: this.options.canEditMinutes,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    agendaItem.isDirty = true;
                }, this),
                onDelete: (attachment, callback) => {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    agendaItem.isDirty = true;
                    callback();
                }
            })
        }, this));
    },
    categoryClicked: function (e) {
        let dropdown = $(e.currentTarget),
            cid = dropdown.data('cid'),
            category = this.model.categories.get(cid),
            collapse = dropdown.next('.collapse'),
            caret = dropdown.find('.category-caret')

        if (!collapse.hasClass('show')) {
            caret.find('i').removeClass('fa-caret-right').addClass('fa-caret-down')
            category.set('isExpanded', true);
        } else {
            caret.find('i').removeClass('fa-caret-down').addClass('fa-caret-right')
            category.set('isExpanded', false);
        }
    },
    editMeetingMinutes: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);

        agendaItem.set('isEditing', true);
        this.renderAgendaItems();
    },
    exportMeeting: function () {
        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});

            this.renderAgendaItems();
        }, this);

        if (this.options.canEdit) {
            this.save(callback);
        } else {
            callback();
        }
    },
    distributeAgendaItems: function () {
        let isMinutes = this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.CONCLUDED || this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.IN_PROGRESS;
        new PJQ.views.modals.YesNo({
            header: "Distribute " + (isMinutes ? "Meeting Minutes?" : "Meeting Agenda?"),
            body: "This will email all attendees the " + (isMinutes ? "meeting minutes" : "agenda") + " for this meeting. Would you like to continue?",
            onYes: _.bind(function () {
                this.model.save(null, {
                    success: _.bind(function () {
                        new PJQ.ajax.Request({
                            isAPIv2: true,
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'meetings',
                                    value: this.model.get('id')
                                },
                                {
                                    endpoint: 'email'
                                }
                            ]),
                        }).post().done(_.bind(function (response) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Successfully distributed'
                            });
                        }, this)).fail(_.bind(function (xhr, err, result) {
                            PJQ.notifications.notify.errorNotify({
                                message: "Encountered an error while distributing this meeting. Please contact customer service."
                            });
                        }, this));
                    }, this)
                }, this)
            }, this)
        });
    },
    saveMeetingMinutesClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        this.saveMeetingMinutes(agendaItem);
        this.renderAgendaItems();
    },
    saveMeetingMinutes: function (agendaItem) {
        if (agendaItem == null || agendaItem.minutesEditor == null) {
            return;
        }

        agendaItem.save({
            minutes: agendaItem.minutesEditor.getValue(),
            isEditing: false
        });
    },
    saveOpenMinutes: function () {
        _.each(this.model.agendaItems.models, (agendaItem) => {
            if (agendaItem.get('isEditing') !== true) {
                return;
            }

            this.saveMeetingMinutes(agendaItem);
        });
        this.renderAgendaItems();
    },
    cancelMeetingMinutes: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);

        agendaItem.set('isEditing', false);
        this.renderAgendaItems();
    },
    addCategoryClicked: function (e) {
        let category = new PJQ.models.meetings.MeetingCategory({
            meetingId: this.model.id
        })

        this.editCategory(category);
    },
    editCategoryClicked: function (e) {
        e.stopPropagation();

        let target = $(e.currentTarget),
            dropdown = target.closest('.category-dropdown'),
            cid = dropdown.data('cid'),
            category = this.model.categories.get(cid);

        this.editCategory(category);
    },
    deleteCategoryClicked: function (e) {
        e.stopPropagation();

        let target = $(e.currentTarget),
            dropdown = target.closest('.category-dropdown'),
            cid = dropdown.data('cid'),
            category = this.model.categories.get(cid);

        this.deleteCategory(category);
    },
    editCategory: function (category) {
        new PJQ.views.meetings.CategoryEditModal({
            meeting: this.model,
            model: category,
            onDelete: _.bind(function (category) {
                this.model.categories.remove(category);
                this.renderAgendaItems();
            }, this),
            onSave: _.bind(function (category, isNew) {
                if (isNew) {
                    this.model.categories.add(category);
                }
                this.renderAgendaItems();
            }, this)
        });
    },
    deleteCategory: function (category) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this category?  This will also delete any items in the category.",
            onDelete: _.bind(function () {
                category.destroy({
                    success: _.bind(function () {
                        this.model.agendaItems.remove(_.filter(this.model.agendaItems.models, function (model) {
                            return model.get('categoryId') === category.id;
                        }, this));
                        this.model.categories.remove(category);
                        this.renderAgendaItems();
                    }, this)
                })
            }, this)
        });
    },
    addAgendaItemClicked: function (e) {
        e.stopPropagation();
        let categoryId = $(e.currentTarget).data('category-id'),
            categoryAgendaItems = this.model.agendaItems.where({categoryId: categoryId == null ? null : categoryId});

        let agendaItem = new PJQ.models.meetings.AgendaItem({
            meetingId: this.model.id,
            priorityId: 1,
            statusId: 1,
            categoryId: categoryId && categoryId !== '' ? parseInt(categoryId) : null,
            sortOrder: _.size(categoryAgendaItems) + 1
        });

        this.editAgendaItem(agendaItem);
    },
    closeAgendaItemClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        agendaItem.set('statusId', PJQ.constants.meetings.meetingAgendaStatus.CLOSED);
        agendaItem.save();
        this.renderAgendaItem(agendaItem);
    },
    openAgendaItemClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        agendaItem.set('statusId', PJQ.constants.meetings.meetingAgendaStatus.OPEN);
        agendaItem.save();
        this.renderAgendaItem(agendaItem);
    },
    editAgendaItemClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        this.editAgendaItem(agendaItem);
    },
    editAgendaItem: function (agendaItem) {
        new PJQ.views.meetings.AgendaItemEditModal({
            meeting: this.model,
            model: agendaItem,
            onDelete: _.bind(function (agendaItem) {
                this.model.agendaItems.remove(agendaItem);
                this.renderAgendaItems();
            }, this),
            onSave: _.bind(function (agendaItem, isNew) {
                if (isNew) {
                    this.model.agendaItems.add(agendaItem);
                    this.renderAgendaItems();
                } else {
                    this.renderAgendaItems();
                }
            }, this)
        });
    },
    deleteAgendaItemClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        this.deleteAgendaItem(agendaItem);
    },
    deleteAgendaItem: function (agendaItem) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this agenda item?",
            onDelete: _.bind(function () {
                this.model.agendaItems.remove(agendaItem);
                agendaItem.destroy();
                this.renderAgendaItems();
            }, this)
        });
    },
    validate: function () {
        let isValid = true;

        if (this.meetingCustomFieldsForm != null && !this.meetingCustomFieldsForm.validate()) {
            isValid = false;
        }

        let $meetingName = this.$('.meeting-name');
        PJQ.helpers.inputHelpers.setInputError($meetingName, true);
        if (this.model.get('name') == null || this.model.get('name').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($meetingName, false);
            isValid = false;
        }

        let $meetingNumber = this.$('.meeting-number');
        PJQ.helpers.inputHelpers.setInputError($meetingNumber, true);
        if (this.model.get('number') == null || this.model.get('number').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($meetingNumber, false);
            isValid = false;
        }

        let $meetingDate = this.$('.meeting-date');
        PJQ.helpers.inputHelpers.setInputError($meetingDate, true);
        if (PJQ.app.session.project && (this.model.get('date') == null || this.model.get('date').length === 0)) {
            PJQ.helpers.inputHelpers.setInputError($meetingDate, false);
            isValid = false;
        }

        let $meetingStartTime = this.$('.meeting-start-time');
        PJQ.helpers.inputHelpers.setInputError($meetingStartTime, true);
        if (this.model.get('startTime') == null || this.model.get('startTime').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($meetingStartTime, false);
            isValid = false;
        }

        let $meetingEndTime = this.$('.meeting-end-time');
        PJQ.helpers.inputHelpers.setInputError($meetingEndTime, true);
        if (this.model.get('endTime') == null || this.model.get('endTime').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($meetingEndTime, false);
            isValid = false;
        }
        return isValid;
    },
    saveMeeting: function () {
        let isNew = this.model.isNew(),
            callback = _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Meeting saved successfully'
                });

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.model, isNew);

                if (!isNew) {
                    this.removeModal();
                } else {
                    this.render();
                }
            }, this);

        this.saveOpenMinutes();
        this.save(callback, isNew);
    },
    save: function (callback, isNew) {
        if (!this.validate()) {
            return;
        }

        if (this.fileUploader.isUploading() || this.recordingUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
            return;
        }

        if (!this.model.get('attendeeIds')) {
            this.model.set('attendeeIds', []);
        }

        this.model.set('customFieldValues', this.meetingCustomFieldsForm != null ? this.meetingCustomFieldsForm.getChanged() : null);

        this.model.save(null, {
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback();
                }
            }, this),
            error: _.bind(function () {
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Meeting. Please contact customer service."
                });
            }, this)
        })
    },
    deleteMeeting: function () {
        let meetingId = this.model.id;
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this meeting?",
            onDelete: _.bind(function () {
                this.model.destroy();
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete();
                    this.removeModal();
                }
            }, this)
        });
    },
    close: function () {
        let editPerms = PJQ.app.session.project.hasPermission('meetings.canEdit');
        if ((this.model.hasChanged() || 0 < _.size(this.model.agendaItems.getChangedModels())) && editPerms) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveMeeting();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.meetings.AgendaItemEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-agenda-item-edit'),
        width: '65%',
        maxWidth: 800,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-save': 'saveAgendaItem',
        'click .btn-delete': 'deleteAgendaItem',
        'click .btn-close': 'close',
        'input .agenda-item-description': 'descriptionChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        if (PJQ.app.session.project) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.canEdit');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canDelete = this.options.isAdmin;
        } else {
            this.options.canEdit = true;
            this.options.isAdmin = true;
            this.options.canDelete = true;
        }

        if (!this.model) {
            this.model = new PJQ.models.meetings.AgendaItem();
        }

        if (this.options.project) {
            this.settings = await this.options.project.fetchMeetingSettings();
        } else {
            this.settings = await PJQ.app.session.fetchMeetingSettings();
        }
        this.isFetched = true;

        this.render();
    },
    beforeRender: function () {
    },
    renderData: function () {
        return {
            model: this.model,
            settings: this.settings,
            meeting: this.options.meeting,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderGeneral();
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });
        let defaultDate = PJQ.helpers.dateHelpers.getDateString(this.model.get('dueDate'), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
        new PJQ.inputs.Datepicker({
            el: this.$('.due-date'),
            canEdit: this.options.canEdit,
            timezone: 'UTC',
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: defaultDate
            },
            onChange: _.bind(function (newDate) {
                let currentDate = this.model.get('date');
                if (currentDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDate)) !== 0) {
                    this.model.set('dueDate', newDate);
                }
            }, this)
        });

        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            defaultValue: this.model.get('statusId') != null ? this.model.get('statusId') : 1,
            canEdit: true,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                let newStatus = value;
                this.model.set('statusId', newStatus);
            }, this)
        });

        if (!this.settings.get('disableAgendaItemPriority')) {
            this.priorityPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-priority'),
                defaultValue: this.model.get('priorityId') != null ? this.model.get('priorityId') : 1,
                canEdit: true,
                isMultiple: false,
                isIntChoices: true,
                onChange: _.bind(function (value) {
                    let newPriority = value;
                    this.model.set('priorityId', newPriority);
                }, this)
            });
        }

        this.categoryPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-category'),
            defaultValue: this.model.get('categoryId'),
            canEdit: true,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                let newCategory = value;
                this.model.set('categoryId', newCategory);
            }, this)
        });

        this.assigneePicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.agenda-assigned-to'),
            selectedContact: this.model.assignedTo,
            isReadOnly: !this.options.canEdit,
            displayContactsBlock: true,
            context: PJQ.app.session.project ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.isDirty = true;
                this.model.assignedTo = selectedContact;
                this.model.set('assignedToId', selectedContact ? selectedContact.get('id') : null);
            }, this)
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.agenda-item-file-uploader'),
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            useApiV2: true,
            canView: false,
            canDelete: this.options.isAdmin,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        })
    },
    descriptionChanged: function(e) {
        let $input = $(e.currentTarget),
            val = $input.val();

        if (typeof val === 'string' && val.length > 4000) {
            val = val.slice(0, 4000);
            $input.val(val);
        }

        this.model.set('description', val);
    },
    validate: function () {
        let isValid = true;

        let $agendaTitle = this.$('.agenda-item-title');
        PJQ.helpers.inputHelpers.setInputError($agendaTitle, true);
        if (this.model.get('title') == null || this.model.get('title').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($agendaTitle, false);
            isValid = false;
        }

        return isValid;
    },
    saveAgendaItem: function () {
        if (!this.validate()) {
            return;
        }
        let isNew = this.model.isNew();
        let callback = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave(this.model, isNew);

            this.removeModal();
        }, this);

        this.save(callback);
    },
    save: function (callback) {
        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
            return;
        }

        if (!this.model.get('assignedToId')) {
            this.model.set('assignedToId', 0);
        }

        this.model.save(null, {
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback();
                }
            }, this),
            error: _.bind(function () {
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this category. Please contact customer service."
                });
            }, this)
        })
    },
    deleteAgendaItem: function () {
        let agendaItemId = this.model.id;
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this agenda item?",
            onDelete: _.bind(function () {
                this.model.destroy();
                if (typeof this.options.onDelete === 'function')
                    this.options.onDelete(this.model);

                this.removeModal();
            }, this)
        });
    },
    close: function () {
        this.removeModal();
    }
});

PJQ.views.meetings.CategoryEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-category-edit'),
        width: '40%',
        maxWidth: 600,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-save': 'saveCategory',
        'click .btn-delete': 'deleteCategory',
        'click .btn-close': 'close',
    },
    beforeModalCreated: function () {
        if (PJQ.app.session.project) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.canEdit');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canDelete = this.options.isAdmin;
        } else {
            this.options.canEdit = true;
            this.options.isAdmin = true;
            this.options.canDelete = true;
        }

        this.isFetched = false;

        if (!this.model) {
            this.model = new PJQ.models.meetings.MeetingCategory();
        }

        if (!this.model.isNew() && !this.model.isFetched) {
            this.model.fetch({
                success: _.bind(function () {
                    this.isFetched = true;
                    this.render();
                }, this)
            });
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    beforeRender: function () {
    },
    renderData: function () {
        return {
            model: this.model,
            meeting: this.options.meeting,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            watchElements: [
                'input',
            ]
        });
    },
    validate: function () {
        let isValid = true;

        let $categoryName = this.$('.category-name');
        PJQ.helpers.inputHelpers.setInputError($categoryName, true);
        if (this.model.get('name') == null || this.model.get('name').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($categoryName, false);
            isValid = false;
        }

        return isValid;
    },
    saveCategory: function () {
        if (!this.validate()) {
            return;
        }
        let isNew = this.model.isNew();
        let callback = _.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Category saved successfully'
            });

            if (typeof this.options.onSave === 'function')
                this.options.onSave(this.model, isNew);

            this.removeModal();
        }, this);

        this.save(callback);
    },
    save: function (callback) {
        this.model.save(null, {
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback();
                }
            }, this),
            error: _.bind(function () {
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this category. Please contact customer service."
                });
            }, this)
        })
    },
    deleteCategory: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this category?  This will also delete any items in the category.",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(this.model);

                        this.removeModal();
                    }, this),
                    error: _.bind(function () {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Something went wrong!'
                        });
                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveCategory();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.meetings.ViewMeetingTranscriptionModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-view-transcription'),
        width: '50%',
        maxWidth: 800,
        model: null,
        isShowCloseButton: true,
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-transcribe': 'transcribeMeeting'
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            recording: this.model,
            meeting: this.options.meeting
        }
    },
    afterRender: function () {

    },
    transcribeMeeting: function () {
        this.loader = new PJQ.Loader(this.$('.generate-transcription-div'));
        new PJQ.ajax.Request({
            isAPIv2: true,
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings',
                    value: this.options.meeting.id
                },
                {
                    endpoint: 'transcribe'
                }
            ]),
        }).get().done(_.bind(function (response) {
            this.model.set('transcriptions', [response]);
            this.loader.remove()
            PJQ.notifications.notify.successNotify({
                message: 'Recording successfully transcribed'
            });
            this.render();
        }, this)).fail(_.bind(function (xhr, err, result) {//todo: error
        }, this));
    },
    close: function () {
        this.removeModal();
    }
});
// Models
PJQ.models.meetings.Meeting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.isNew() && this.get('projectId')) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'meetings',
                    value: this.id
                }
            ]);
        } else if (this.isNew() && this.get('templateId')) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'templates',
                    value: this.get('templateId')
                },
                {
                    endpoint: 'meeting'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings',
                    value: this.id
                }
            ]);
        }
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.meetings.Attachments(model.attachments);
        this.meetingRecordings = new PJQ.collections.meetings.Attachments(model.meetingRecordingAttachments);
        this.agendaItems = new PJQ.collections.meetings.AgendaItems(model.agendaItems);
        this.categories = new PJQ.collections.meetings.MeetingCategories(model.categories);
        this.attendees = new PJQ.collections.meetings.MeetingAttendees(model.attendees);

        let noCategory = new PJQ.models.meetings.MeetingCategory({
            meetingId: this.id,
            id: null,
            name: 'No Category'
        });

        this.categories.add(noCategory);

        return model;
    },
    beforeSave: function () {
        let agendaItems = this.agendaItems.getChangedModels();
        _.each(agendaItems, function (agendaItem) {
            agendaItem.beforeSave();
        }, this);

        this.set({
            attachments: this.attachments,
            meetingRecordingAttachments: this.meetingRecordings,
            attendees: this.attendees,
            agendaItems: agendaItems,
            categories: this.categories.filter(function (category) {
                return category.id !== null;
            })
        });
    },
    validateHyperlink: function () {
        let hyperlink = this.get('meetingLink'),
            urlPattern = /^(https?:\/\/)?([^\s/$.?#].[^\s]*)\.[^\s]+$/;

        if (!urlPattern.test(hyperlink)) {
            return false;
        }

        if (!hyperlink.startsWith("https://")) {
            hyperlink = "https://" + hyperlink;
        }

        return hyperlink;
    },
    isToday: function () {
        if (this.get('date')) {
            return (new Date(this.get('date').replace('Z', ''))).setHours(0, 0, 0, 0) === (new Date()).setHours(0, 0, 0, 0);
        } else {
            return false;
        }
    },
    getDateAndTime: function (dataProp = 'start') {
        let meetingDate = PJQ.helpers.dateHelpers.parseDateString(this.get('date'), false);
        if (meetingDate == null) {
            return null;
        }

        let mTime;
        if (dataProp === 'end') {
            mTime = this.get('endTime')
        } else {
            mTime = this.get('startTime')
        }

        if (_.size(mTime) === 0) {
            return null;
        }


        let timeSplit = mTime.split(':');
        if (timeSplit.length < 2) {
            return null;
        }

        let hours = parseInt(timeSplit[0]),
            minutes = parseInt(timeSplit[1]);
        if (isNaN(hours) || isNaN(minutes)) {
            return null;
        }

        meetingDate.setHours(hours, minutes);
        return meetingDate;
    },
    isOverdue: function () {
        let mDateTime = this.getDateAndTime();
        if (mDateTime == null) {
            return false;
        }

        return this.get('statusId') === PJQ.constants.meetings.meetingStatus.SCHEDULED && this.getDateAndTime() < new Date();
    },
    durationInMinutes: function () {
        let startDateTime = this.getDateAndTime(),
            endDateTime = this.getDateAndTime('end');

        if (startDateTime == null || endDateTime == null) {
            return null;
        }

        return PJQ.helpers.dateHelpers.getDateDiff(endDateTime, startDateTime, 'minutes');
    }
});

PJQ.models.meetings.CustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.meetings.CustomFieldChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'customfields',
                value: this.get('customFieldId')
            },
            {
                endpoint: 'choices',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.meetings.Settings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }
    }
});

PJQ.models.meetings.UserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.meetings.AgendaItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.get('meetingId') ? this.get('meetingId') : this.options.meetingId
            },
            {
                endpoint: 'agendaitems',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.meetings.Attachments(model.attachments);

        if (model && model.assignedTo) {
            if (model.assignedTo instanceof PJQ.models.BaseModel) {
                this.assignedTo = model.assignedTo;
            } else {
                this.assignedTo = new PJQ.models.contacts.Contact(model.assignedTo);
            }
        } else {
            this.assignedTo = null;
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments,
            assignedTo: this.assignedTo
        });
    },
    updateSort: function () {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/updatesort',
            isAPIv2: true,
            data: this.toJSON()
        }).put().done(_.bind(function (res) {

        }, this)).fail(_.bind(function (xhr, err, result) {

        }, this));
    }
});

PJQ.models.meetings.MeetingAttendee = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    parse: function (model) {
        if (!model)
            return model;

        this.attendee = new PJQ.models.contacts.Contact(model.attendee);

        return model;
    },
})

PJQ.models.meetings.MeetingCategory = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.get('meetingId') ? this.get('meetingId') : this.options.meetingId
            },
            {
                endpoint: 'categories',
                value: this.id
            }
        ]);
    },
    updateSort: function () {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/updatesort',
            isAPIv2: true,
            data: this.toJSON()
        }).put().done(_.bind(function (res) {

        }, this)).fail(_.bind(function (xhr, err, result) {

        }, this));
    }
});

PJQ.models.meetings.Template = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    notifyName: 'Template',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'templates',
                value: !this.get('projectId') ? this.id : null
            }
        ], this.get('projectId') > 0 ? [
            {
                parameter: 'projectId',
                value: this.get('projectId')
            },
            {
                parameter: 'copyAttendees',
                value: this.get('copyAttendees')
            },
            {
                parameter: 'copyAgendaItems',
                value: this.get('copyAgendaItems')
            },
            {
                parameter: 'copyCategories',
                value: this.get('copyCategories')
            },
            {
                parameter: 'copyAttachments',
                value: this.get('copyAttachments')
            },
            {
                parameter: 'overwriteExisting',
                value: this.get('overwriteExisting')
            }
        ] : null);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.meetings) {
            this.meetings = new PJQ.collections.meetings.Meetings(model.meetings);
        } else {
            this.meetings = new PJQ.collections.meetings.Meetings();
        }

        return model;
    }
});

PJQ.models.meetings.Attachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});
//Collections

PJQ.collections.meetings.Meetings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.Meeting,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'meetings'
            }
        ], params);
    },
    getOriginMeetings: function () {
        let originMeetings = new PJQ.collections.meetings.Meetings(),
            self = this,
            nonExistentOriginMeetings = [];

        // Create a map of all meeting ids for fast existence check
        let meetingIds = this.models.map(function (model) {
            return model.id;
        });

        _.each(this.models, function (model) {
            let originMeetingId = model.get('originMeetingId');

            // Add to originMeetings if originMeetingId is null
            if (!originMeetingId) {
                originMeetings.add(model);
                model.followUpMeetings = new PJQ.collections.meetings.Meetings();
                model.followUpMeetings.add(model);
            } else if (!meetingIds.includes(originMeetingId)) {
                // If origin meeting does not exist, add it to a separate list
                nonExistentOriginMeetings.push(model);
            }
        }, this);

        // Sort the nonExistentOriginMeetings by id
        nonExistentOriginMeetings.sort(function (a, b) {
            return a.id - b.id;
        });

        // Take the first (lowest id) of each originMeetingId group as originMeeting and the rest as followUpMeetings
        let groupedNonExistentOriginMeetings = _.groupBy(nonExistentOriginMeetings, function (model) {
            return model.get('originMeetingId');
        });
        _.each(groupedNonExistentOriginMeetings, function (group) {
            let originMeeting = group[0];
            originMeetings.add(originMeeting);
            originMeeting.followUpMeetings = new PJQ.collections.meetings.Meetings();

            _.each(group, function (followUpMeeting) {
                originMeeting.followUpMeetings.add(followUpMeeting);
            });
        });

        // For each originMeeting, find and add to its followUpMeetings the meetings whose originMeetingId is its id
        _.each(originMeetings.models, function (originMeeting) {
            _.each(self.models, function (model) {
                if (model.get('originMeetingId') === originMeeting.id) {
                    originMeeting.followUpMeetings.add(model);
                }
            });
        });

        return originMeetings;
    },
    getMeetingCount: function (meetingId) {
        return _.size(this.get(meetingId).followUpMeetings);
    },
    getMeetingsFromOrigin: function (meeting) {
        let result = [],
            originMeetingId = meeting.get('originMeetingId');
        if (originMeetingId > 0) {
            result.push(...this.where({originMeetingId: originMeetingId}))
        } else {
            result.push(meeting);
            result.push(...this.where({originMeetingId: meeting.id}))
        }
        return result;
    }
});

PJQ.collections.meetings.Attachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.Attachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.options.meetingId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.meetings.MeetingCategories = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.MeetingCategory,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.options.meetingId
            },
            {
                endpoint: 'categories'
            }
        ], params);
    }
});

PJQ.collections.meetings.AgendaItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.AgendaItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings',
                value: this.options.meetingId
            },
            {
                endpoint: 'agendaitems'
            }
        ], params);
    }
});

PJQ.collections.meetings.MeetingAttendees = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.MeetingAttendee,
    getAttendeeContacts: function () {
        return _.map(this.models, function (model) {
            return model.attendee;
        });
    }
});

PJQ.collections.meetings.CustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.CustomField,
    endpoint: function () {
        let params = [];
        if (this.options.projectId) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'customfields'
                }
            ], params);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'customfields'
                }
            ], params);
        }
    }
});

PJQ.collections.meetings.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.CustomFieldChoice
});

PJQ.collections.meetings.Templates = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.meetings.Template,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'meetings'
            },
            {
                endpoint: 'templates'
            }
        ]);
    }
});
PJQ.views.meetings.MeetingListDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Meetings'
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'data-table-header-meetings')
        },
        paging: false
    },
    events: {},
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['number', 'name', 'description', 'date', 'meetingTime', 'location', 'status'];

        this.options.order = [0, 'desc'];

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "width": "100px",
                        "render": (data, type, row) => {
                            if (type === 'sort' || type === 'type') {
                                return data;
                            }

                            return '<a href="javascript:void(0)" class="btn-view-meeting" data-cid="' + row.cid + '">' + data + '</a>';
                        },
                    });
                    break;
                case 'name':
                    columns.push({
                        "columnData": "name",
                        "data": "attributes.name",
                        "title": "Name"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'date':
                    columns.push({
                        "columnData": "date",
                        "data": "attributes.date",
                        "title": 'Meeting Date',
                        "width": '150px',
                        "render": (data, type, row) => {
                            if (_.size(data) === 0) {
                                return '';
                            }
                            return PJQ.helpers.dateHelpers.getDateString(data, PJQ.helpers.dateHelpers.dateFormats.DATE, true)
                        }
                    });
                    break;
                case 'meetingTime':
                    columns.push({
                        "columnData": "meetingTime",
                        "data": "",
                        "title": 'Meeting Time',
                        "width": '150px',
                        "render": (data, type, row) => {
                            return this.parseTimeString(row.get('startTime')) + ' - ' + this.parseTimeString(row.get('endTime')) + ' ' + (row.get('timezone') ?? 'CDT');
                        }
                    });
                    break;
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": (data, type, row) => {
                            return PJQ.constants.meetings.meetingStatusNames[row.get('statusId')]
                        }
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue') && this.customFields) {
                        _.each(this.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue / 100, true)).toFixed(2)
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue / 100, true)).toFixed(2) + '%' : '';
                                                }

                                                break;
                                        }
                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": (data, type, row) => {
                    let html = '<div class="show-on-row-hover">',
                        status = row.get('statusId'),
                        targetMeeting = row,
                        originMeetingId = targetMeeting.get('originMeetingId'),
                        originMeeting = originMeetingId ? targetMeeting.collection.get(originMeetingId) : targetMeeting,
                        mostRecentMeeting = originMeeting ? _.max(originMeeting.followUpMeetings.models, function (model) {
                            return model.id;
                        }) : null;
                    if (this.options.canViewMeetings) {
                        html += '<button type="button" class="btn btn-info btn-view-meeting ml-1" data-cid="' + (row.cid) + '" title="View meeting"><i class="fal fa-arrow-alt-from-left"></i></button>';
                    }
                    if (this.options.canDeleteMeetings && mostRecentMeeting === targetMeeting) {
                        html += '<button type="button" class="btn btn-danger btn-delete-meeting ml-1" data-cid="' + (row.cid) + '" title="Delete meeting"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>'
                    return html
                },
                "orderable": false,
                "searchable": false,
                "width": "100px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    parseTimeString: function (timeString) {
        let timeArray = timeString.split(":"), // split the time string into an array
            time = new Date(),
            options = {hour: "numeric", minute: "numeric", hour12: true};
        time.setHours(timeArray[0]); // set the hours
        time.setMinutes(timeArray[1]); // set the minutes
        time.setSeconds(0); // set the seconds
        return time.toLocaleTimeString("en-US", options);
    },
    getFilterData: function () {
        let result = this.options.data,
            statusFilter = this.getFilter('status');
        if (_.size(statusFilter) === 0) {
            return result;
        }

        return _.filter(result, function (row) {
            return _.contains(statusFilter, row.get('statusId'));
        });
    },
});
PJQ.views.meetings.MeetingsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'meetings-list'),
        subTemplates: {
            comments: new PJQ.templating.Template(PJQ.constants.modules.ACTIONITEMS, 'Action-Item-Comments'),
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts'),
            meeting: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'meeting'),
        },
        meetingId: null
    },
    events: {
        'shown.bs.collapse .meeting-collapse': 'meetingExpanded',
        'hidden.bs.collapse .meeting-collapse': 'meetingCollapsed',
        'click .btn-settings': 'editSettings',
        'keyup .meeting-search': 'searchChanged',
        'click .clear-filters': 'clearFilters',
        'click .btn-add-meeting': 'addMeetingClicked',
        'click .btn-delete-meeting': 'deleteMeetingClicked',
        'click .btn-view-meeting': 'viewMeetingClicked',
        'click .meeting-dropdown': 'meetingClicked',
        'click .btn-follow-up': 'followUpMeetingClicked',
        'click .btn-import-template': 'importTemplate',
        'click .btn-save-a-template': 'saveTemplate'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.expandedMeetings = [];
        if (this.collection == null && PJQ.app.session.project) {
            this.collection = new PJQ.collections.meetings.Meetings(null, {
                projectId: PJQ.app.session.project.id
            });
        }
        this.isFetched = false;

        if (!this.collection.isFetched && this.options.project) {
            await this.collection.fetch();
        }
        this.originMeetings = this.collection.getOriginMeetings();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched)
            return;

        if (this.options.project) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canAdd = PJQ.app.session.project.hasPermission('meetings.canAdd');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canDelete = this.options.isAdmin;
        } else {
            this.options.canEdit = true;
            this.options.canAdd = true;
            this.options.isAdmin = true;
            this.options.canDelete = true;
        }
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            meetings: this.collection,
            originMeetings: this.originMeetings,
            canEdit: this.options.canEdit,
            canAdd: this.options.canAdd,
            isAdmin: this.options.isAdmin,
            project: PJQ.app.session.project
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.inputs.Selectpicker({
            el: this.$('.meeting-status-filter'),
            defaultValue: null,
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.statusFilter = value;
                this.renderMeetings();
            }, this)
        });

        if (this.options.meetingId > 0) {
            let initMeeting = this.collection.get(this.options.meetingId);
            if (initMeeting != null) {
                this.viewMeeting(initMeeting);
                this.options.meetingId = null;
            }
        }

        this.renderMeetings();
    },
    meetingCollapsed: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            meeting = this.collection.get(cid),
            originId = meeting.get('originMeetingId') > 0 ? meeting.get('originMeetingId') : meeting.id;
        this.expandedMeetings = _.without(this.expandedMeetings, originId);
    },
    meetingExpanded: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            meeting = this.collection.get(cid),
            originId = meeting.get('originMeetingId') > 0 ? meeting.get('originMeetingId') : meeting.id;
        if (this.expandedMeetings.indexOf(originId) === -1) {
            this.expandedMeetings.push(originId);
        }
    },
    searchChanged: function (e) {
        this.search = $(e.currentTarget).val();
        this.renderMeetings();
    },
    clearFilters: function () {
        this.search = '';
        this.statusFilter = null;
        this.render();
    },
    renderMeetings: function () {
        let $meetings = this.$('.meetings-container');
        $meetings.empty();

        let meetings = this.originMeetings.models;
        if (_.size(this.search) > 0 || _.size(this.statusFilter) > 0) {
            let filteredMeetings = this.collection.models;
            if (_.size(this.search) > 0) {
                filteredMeetings = _.filter(filteredMeetings, _.bind(function (meeting) {
                    if ((meeting.get('number') + ' ' + meeting.get('name') + ' ' + meeting.get('description')).toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
                        return true;
                    }
                }, this));
            }

            if (_.size(this.statusFilter) > 0) {
                filteredMeetings = _.filter(filteredMeetings, _.bind(function (meeting) {
                    if (this.statusFilter.indexOf(meeting.get('statusId')) !== -1) {
                        return true;
                    }
                }, this));
            }

            let filteredOriginMeetingIds = _.uniq(_.map(filteredMeetings, function (meeting) {
                return meeting.get('originMeetingId') > 0 ? meeting.get('originMeetingId') : meeting.id;
            }));
            meetings = _.filter(meetings, function (meeting) {
                return filteredOriginMeetingIds.indexOf(meeting.id) !== -1;
            })
        }

        if (_.size(meetings) === 0) {
            $meetings.append(`<div class="wd-100 d-flex" style="height: 80%">
                    <div class="mb-auto mt-auto wd-100 text-align-center d-flex flex-column justify-content-center align-content-center text-muted">
                        <div class="fs-24">
                            No meetings found matching your search
                        </div>
                    </div>
                </div>`)
        }

        _.each(meetings, _.bind(function (meeting) {
            this.renderSubTemplate(true, this.options.subTemplates.meeting, $meetings, {
                expandedMeetings: this.expandedMeetings,
                meetings: this.collection,
                originMeetings: this.originMeetings,
                meeting: meeting,
                canEdit: this.options.canEdit,
                canAdd: this.options.canAdd,
                isAdmin: this.options.isAdmin,
                project: PJQ.app.session.project
            }, _.bind(function (el) {
                meeting.dataTable = new PJQ.views.meetings.MeetingListDatatable({
                    el: el.find(".meeting-" + meeting.cid + "-table"),
                    rowId: "cid",
                    data: meeting.followUpMeetings.models,
                    canViewMeetings: true,
                    canDeleteMeetings: this.options.isAdmin,
                    onPageSizeChange: function (value) {

                    },
                    isAdmin: true,
                    headerData: _.bind(function () {
                        return {
                            project: this.options.project,
                            canAdd: this.options.canEdit,
                            isAdmin: this.options.isAdmin
                        };
                    }, this),
                    onRowDoubleClick: _.bind(function (row) {
                        this.viewMeeting(row.data());
                    }, this),
                    contextMenuOptions: {
                        actions: [
                            {
                                name: 'View',
                                onClick: _.bind(function (row) {
                                    this.viewMeeting(row.data());
                                }, this)
                            },
                            {
                                name: 'Delete',
                                isDanger: true,
                                onClick: _.bind(function (row) {
                                    this.deleteMeeting(row);
                                }, this),
                                isShown: _.bind(function (row) {
                                    let targetMeeting = row.data(),
                                        originMeetingId = targetMeeting.get('originMeetingId'),
                                        originMeeting = originMeetingId ? this.collection.get(originMeetingId) : targetMeeting,
                                        mostRecentMeeting = originMeeting ? _.max(originMeeting.followUpMeetings.models, function (model) {
                                            return model.id;
                                        }) : null;

                                    return mostRecentMeeting === targetMeeting && this.options.isAdmin;
                                }, this)
                            }
                        ]
                    }
                });


                meeting.dataTable.setFilter('status', this.statusFilter);
                if (_.size(this.search) > 0) {
                    meeting.dataTable.search(this.search.toLowerCase());
                }
            }, this));
        }, this));
    },
    meetingClicked: function (e) {
        let dropdown = $(e.currentTarget),
            collapse = dropdown.next('.collapse'),
            caret = dropdown.find('.meeting-caret')
        if (!collapse.hasClass('show')) {
            caret.find('i').removeClass('fa-caret-right').addClass('fa-caret-down')
        } else {
            caret.find('i').removeClass('fa-caret-down').addClass('fa-caret-right')
        }
    },
    saveTemplate: function () {
        new PJQ.views.meetings.MeetingTemplateCreatorModal({
            collection: this.collection,
            project: PJQ.app.session.project
        });
    },
    importTemplate: function () {
        new PJQ.views.meetings.ImportTemplateModal({
            project: PJQ.app.session.project,
            onImport: _.bind(function (meetings) {
                this.collection = meetings;
                this.originMeetings = this.collection.getOriginMeetings();
                this.render();
            }, this)
        });
    },
    followUpMeetingClicked: function (e) {
        e.stopPropagation();
        let target = $(e.currentTarget),
            dropdown = target.closest('.meeting-dropdown'),
            cid = dropdown.data('cid'),
            originMeeting = this.collection.get(cid),
            previousMeeting = _.max(originMeeting.followUpMeetings.models, function (model) {
                return model.id;
            });

        // We want to carry over the attendees from the previous meeting, so we have to fetch the previous meeting.
        previousMeeting.fetch({
            success: _.bind(function (previousMeeting) {
                // Need to reset the attendance from previous meeting
                if (previousMeeting.get('attendees') != null) {
                    _.each(previousMeeting.get('attendees'), (attendee) => {
                        attendee.isPresent = false;
                        attendee.isAbsent = false;
                        attendee.isDistribution = false;
                    });
                }

                followUpMeeting = new PJQ.models.meetings.Meeting({
                    originMeetingId: originMeeting.get('id'),
                    number: _.size(originMeeting.followUpMeetings) + 1,
                    startTime: previousMeeting.get('startTime'),
                    endTime: previousMeeting.get('endTime'),
                    name: previousMeeting.get('name'),
                    description: previousMeeting.get('description'),
                    attendeeIds: previousMeeting.get('attendeeIds'),
                    attendees: previousMeeting.get('attendees'),
                    projectId: PJQ.app.session.project ? PJQ.app.session.project.id : null,
                    templateId: previousMeeting.get('templateId'),
                    statusId: PJQ.constants.meetings.meetingStatus.DRAFT
                })
                this.viewMeeting(followUpMeeting);
            }, this)
        })
    },
    addMeetingClicked: function (e) {
        let meeting = new PJQ.models.meetings.Meeting({
            projectId: PJQ.app.session.project ? PJQ.app.session.project.id : null,
            templateId: this.options.templateId,
            statusId: PJQ.constants.meetings.meetingStatus.DRAFT,
            number: 1
        })

        this.viewMeeting(meeting);
    },
    editSettings: function () {
    },
    viewMeetingClicked: function (e) {
        // let row = this.dataTable.getRow((e.currentTarget).closest('tr'));
        // this.viewMeeting(row.data());
        let cid = $(e.currentTarget).data('cid'),
            meeting = this.collection.get(cid);
        if (meeting) {
            this.viewMeeting(meeting);
        }
    },
    viewMeeting: function (meeting) {
        let originMeeting = meeting.get('originMeetingId') ? this.collection.get(meeting.get('originMeetingId')) : meeting,
            mostRecentMeeting = originMeeting && originMeeting.followUpMeetings ? _.max(originMeeting.followUpMeetings.models, function (model) {
                return model.id;
            }) : meeting;
        new PJQ.views.meetings.MeetingEditModal({
            model: meeting,
            meetings: this.collection,
            isMostRecentMeeting: mostRecentMeeting === meeting || meeting.isNew(),
            onDelete: _.bind(function () {
                this.renderMeetings();
            }, this),
            onSave: _.bind(function (model, isNew) {
                let originMeeting = model.get('originMeetingId') ? this.originMeetings.get(model.get('originMeetingId')) : model;
                if (isNew) {
                    this.collection.add(model);
                    if (originMeeting !== model) {
                        originMeeting.followUpMeetings.add(model);
                    } else {
                        model.followUpMeetings = new PJQ.collections.meetings.Meetings(model);
                        this.originMeetings.add(model);
                    }
                }
                if (_.size(this.collection) <= 1) {
                    this.render();
                } else {
                    this.renderMeetings();
                }
            }, this)
        });
    },
    deleteMeetingClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.data('cid'),
            meeting = this.collection.get(cid),
            originMeeting = meeting.get('originMeetingId') ? this.collection.get(meeting.get('originMeetingId')) : meeting,
            row = originMeeting.dataTable.getRow(cid);

        this.deleteMeeting(row);
    },
    deleteMeeting: function (row) {
        if (row != null) {
            let meeting = row.data();
            if (meeting != null) {
                let originMeeting = this.collection.get(meeting.get('originMeetingId')),
                    dataTable = originMeeting ? originMeeting.dataTable : meeting.dataTable;

                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Meeting",
                    body: "Are you sure you want to delete this Meeting?",
                    onDelete: _.bind(function () {
                        meeting.destroy({
                            success: _.bind(function () {
                                this.renderMeetings();
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(meeting);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    }
});
PJQ.views.meetings.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
    beforeFirstRender: function () {
        this.collection = new PJQ.collections.meetings.Templates();
        this.listenTo(this.collection, 'fetch', this.render);
        this.collection.fetch();
    },
    addTemplate: function () {
        new PJQ.views.templates.NewTemplateModal({
            model: new PJQ.models.meetings.Template(),
            onSave: _.bind(function (template) {
                this.collection.add(template);
                this.editTemplate(template);
            }, this)
        });
    },
    editTemplate: function (template) {
        new PJQ.views.meetings.EditTemplateModal({
            model: template,
            onClose: _.bind(function () {
                this.dataTable.refresh();
            }, this),
            onDelete: _.bind(function (template) {
                if (template.id > 0) {
                    let row = this.dataTable.getRow(template.cid);
                    this.collection.remove(template);
                    template.destroy();
                    this.dataTable.removeRow(row);
                }
            }, this)
        });
    }
});

PJQ.views.meetings.EditTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'Modal-Edit-Template'),
        maxWidth: '90%',
        fitHeight: true,
        onClose: null
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-delete': 'deleteTemplate'
    },
    beforeModalCreated: function () {
        this.listenTo(this.model, 'fetch', this.render);
        this.model.fetch();
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        if (this.model.isFetched) {

            new PJQ.inputs.TextEditorInput({
                el: this.$('.edit-template-name'),
                label: 'Name',
                value: this.model.get('name'),
                onSave: _.bind(function (value) {
                    this.model.patch({
                        name: value
                    });
                }, this)
            });

            new PJQ.views.meetings.MeetingsList({
                el: this.$('.manage-template'),
                templateId: this.model.id,
                model: this.model,
                collection: this.model.meetings
            });
        }
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.model);
        }
    },
    deleteTemplate: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this template?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.meetings.ImportTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-import-template'),
        maxWidth: 500,
        onImport: null
    },
    events: {
        'click .btn-import': 'save'
    },
    beforeModalCreated: function () {
        this.options.project.fetchMeetingTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            this.templatePicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-template'),
                onChange: _.bind(function (value) {
                    this.selectedTemplate = this.templates.get(value);
                }, this),
                isIntChoices: true,
                noneSelectedText: 'Select Template'
            });

        }
    },
    save: function () {
        let isValid = true;
        if (this.selectedTemplate == null) {
            this.templatePicker.showError();
            isValid = false;
        }
        else {
            this.templatePicker.hideError();
        }


        if (!isValid) {
            return;
        }

        new PJQ.ajax.Request({
            isAPIv2: true,
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'meetings'
                },
                {
                    endpoint: 'import',
                    value: this.selectedTemplate.id
                }
            ], [
                {
                    parameter: 'importAttendees',
                    value: this.$('.input-import-attendees').prop('checked')
                },
                {
                    parameter: 'importAgendaItems',
                    value: this.$('.input-import-agenda-items').prop('checked')
                },
                {
                    parameter: 'importCategories',
                    value: this.$('.input-import-categories').prop('checked')
                },
                {
                    parameter: 'importAttachments',
                    value: this.$('.input-import-attachments').prop('checked')
                }
            ])
        }).put().done(_.bind(function (response) {
            if (typeof this.options.onImport === 'function') {
                let result = new PJQ.collections.meetings.Meetings(response);
                result.isFetched = true;
                this.options.onImport(result);
            }
            this.removeModal();
            PJQ.notifications.notify.successNotify({
                message: 'Meeting Template Imported'
            });
        }, this));
    }
});

PJQ.views.meetings.MeetingTemplateCreatorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-create-template'),
        width: '30%'
    },
    events: {
        'click .btn-save' : 'save'
    },
    beforeModalCreated: function () {
        this.model = new PJQ.models.meetings.Template({
            projectId: this.options.project.id
        });

        this.options.project.fetchMeetingTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates,
            meetings: this.collection
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-meeting'),
                isMultiple: true,
                noneSelectedText: 'Select Meeting #',
                onChange: _.bind(function (value) {

                }, this)
            });

            new PJQ.inputs.AutocompleteInput({
                el: this.$('.input-template-name'),
                source: _.map(this.templates.models, function (template) {
                    return template.get('name')
                })
            });
        }
    },
    save: function () {
        let $name = this.$('.input-template-name'),
            name = $name.val();
        if (_.size(name.trim()) === 0) {
            PJQ.helpers.inputHelpers.setInputError($name);
            return;
        }
        else {
            PJQ.helpers.inputHelpers.setInputError($name, true);
        }

        let existingTemplate = this.templates.findWhere({name: name}),
            overwriteExisting = this.$('.input-overwrite-existing').prop('checked'),
            fnSave = _.bind(function () {
                this.model.set({
                    name: name,
                    copyAttachments: this.$('.input-copy-attachments').prop('checked'),
                    copyAttendees: this.$('.input-copy-attendees').prop('checked'),
                    copyCategories: this.$('.input-copy-categories').prop('checked'),
                    copyAgendaItems: this.$('.input-copy-agenda-items').prop('checked'),
                    overwriteExisting: overwriteExisting
                });
                this.model.save(null, {
                    success: _.bind(function () {
                        this.removeModal();
                        PJQ.notifications.notify.successNotify({
                            message: 'Meeting Template Created'
                        });
                    }, this)
                });
            }, this);
        if (existingTemplate != null) {
            new PJQ.views.modals.YesNo({
                header: "Add to Template?",
                body: !overwriteExisting ? "A template already exists with this name.  Would you like to add these meetings to it?" : "A template already exists with this name. Are you sure you'd like to overwrite this template?",
                onYes: _.bind(function () {
                    this.model.set('id', existingTemplate.id);
                    fnSave();
                }, this)
            });
        }
        else {
            fnSave();
        }
    }
});